import { writable } from 'svelte/store';

// Initialize currentUser from localStorage if it exists
const storedUser = localStorage.getItem('currentUser');
export const currentUser = writable(storedUser ? JSON.parse(storedUser) : null);

// Subscribe to changes and update localStorage
currentUser.subscribe(value => {
    if (value) {
        localStorage.setItem('currentUser', JSON.stringify(value));
    } else {
        localStorage.removeItem('currentUser');
    }
});

export const selectedItem = writable(null);
export let displayDetailedRating = writable(false);
export let ratingLoading = writable(false);
export let toggleLoanInfo = writable(false);
export let toggleLoanInfoEconomy = writable(false);
export let toggleNettoskuldInfo = writable(false);
export let toggleNumberOfApartmentsInfo = writable(false);
export let togglelivingAreaSqmInfo = writable(false);
export let toggleAvgiftPerKvmInfo = writable(false);
export let toggleNetRevenueInfo = writable(false);
export let toggleRiskForFeeIncreaseInfo = writable(false);
export let toggleSolidityInfo = writable(false);
export let toggleNettoresultatInfo = writable(false);
export let toggleNettoskuldInfoEconomy = writable(false);
export let loginLoading = writable(false);
export const fileUploadLoading = writable(false);
export const fileUploadLoadingDone = writable(false);
export const analyzeLoading = writable(false);
export const analyzeLoadingDone = writable(false);
export const createRedovisningExpertLoading = writable(false);
export const createRedovisningExpertLoadingDone = writable(false);
export let brfListLoading = writable(false);
export let objects = writable([]);
export let searchTerm = writable('');
export let redovisning = writable(null);
export let question = writable(null);
export let answer = writable("");
export let questioning = writable(false);
export let chatHistory = writable([]);
export let analyzeEnergyLoading = writable(false);
export let analyzeEnergyLoadingDone = writable(false);

// Årsredovisning specific
export const stadgarUploadLoading = writable(false);
export const stadgarUploadLoadingDone = writable(false);
export const analyzeStadgarLoading = writable(false);
export const analyzeStadgarLoadingDone = writable(false);
export const createStadgarExpertLoading = writable(false);
export const createStadgarExpertLoadingDone = writable(false);

// Energy specific
export const energyUploadLoading = writable(false);
export const energyUploadLoadingDone = writable(false);
